import { render, staticRenderFns } from "./ProfielEditButton.vue?vue&type=template&id=8fb61fc6&"
import script from "./ProfielEditButton.vue?vue&type=script&lang=ts&"
export * from "./ProfielEditButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports